import { apiEndpoint, BACKEND } from '../utils/api';

export const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'critical-application-form-data',
});

export async function fetchCriticalApplicationFormData(uuid: string, payload: string) {
    return backendEndpoint.get('/', { params: { uuid, payload } });
}
